import { AppBar, Tabs, Tab } from '@mui/material';
import { useQuery } from 'react-query';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { getMaterialGeneralInfo } from '../../../fetch';
import { IMaterialGeneralInfo } from '../../../models';
import { GeneralInformation } from './general-information';

export const enum materialPages {
  genInfo
}
interface IEditMaterial {}

export const EditMaterial: FC<IEditMaterial> = () => {
  const classes = useStyles();
  const [selectedPage, setSelectedPage] = useState<materialPages>(materialPages.genInfo);
  const [selectedTab, setSelectedTab] = useState(window.location.pathname);
  const [isDirtyForm, setDirtyForm] = useState<boolean>(false);
  const { materialId }: { materialId: string } = useParams();
  const history = useHistory();

  const {
    isLoading: isLoadingGeneralInfo,
    data: generalInfo,
    refetch: refetchGeneralInfo
  } = useQuery<IMaterialGeneralInfo, Error>(['material-general-info', materialId], () =>
    getMaterialGeneralInfo(materialId)
  );

  useEffect(() => {
    if (window.location.href.includes('general-information')) {
      setSelectedPage(materialPages.genInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href, materialId]);

  const getMaterialId = () => {
    return materialId ? materialId : 'add';
  };
  const materialLinks = useMemo(
    () =>
      [
        {
          name: 'General Information',
          url: `/development/parts/manage-materials/${getMaterialId()}/general-information`
        }
      ].filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [materialId]
  );

  const showLoader = isLoadingGeneralInfo;
  const title = showLoader ? 'Loading...' : `Edit: ${generalInfo.name} `;

  return (
    <Page title={title}>
      <>
        <PageTitleWithBack
          title={title}
          backText="Back to materials"
          backUrl="/development/parts/manage-materials"
        />
        {materialId !== 'add' && (
          <AppBar position="static" color="default" component="div" className={classes.tabBar}>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_, value) => {
                if (!isDirtyForm) {
                  setSelectedTab(value);
                  history.push(value);
                } else {
                  const result = window.confirm(
                    'You have unsaved changes, are you sure you want to exit?'
                  );
                  if (result) {
                    setSelectedTab(value);
                    history.push(value);
                  } else {
                    return;
                  }
                }
              }}
              variant="scrollable"
            >
              {materialLinks.map(link => {
                return (
                  <Tab
                    value={link.url}
                    key={link.name}
                    id={`${link.name}-information`}
                    aria-controls={`${link.name}-information`}
                    label={link.name}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )}
        {selectedPage === materialPages.genInfo && (
          <GeneralInformation
            setDirtyForm={setDirtyForm}
            generalInfo={generalInfo}
            isLoadingGeneralInfo={isLoadingGeneralInfo}
            refetchGeneralInfo={refetchGeneralInfo}
          />
        )}
      </>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
